/* Header announcements (snippets/adelaide-announcements.liquid): shows one message at a time and fades to the next
   every few seconds (Header → Announcement change speed). Pauses while the shopper hovers or tabs into it, and while
   the tab is in the background. In the theme editor, selecting an Announcement block shows that message. */
if (!customElements.get('adelaide-announcements')) {
  customElements.define('adelaide-announcements', class extends HTMLElement {
    connectedCallback() {
      this.items = [...this.querySelectorAll(':scope > .adelaide-announcements__item')];
      if (this.items.length < 2) return;
      this.index = Math.max(0, this.items.findIndex((item) => item.classList.contains('is-active')));
      this.delay = Math.max(2000, Number(this.dataset.interval) || 5000);
      this.paused = false;
      const pause = () => { this.paused = true; };
      const resume = () => { this.paused = false; };
      this.addEventListener('mouseenter', pause);
      this.addEventListener('mouseleave', resume);
      this.addEventListener('focusin', pause);
      this.addEventListener('focusout', resume);
      this.addEventListener('shopify:block:select', (event) => {
        const found = this.items.indexOf(event.target.closest('.adelaide-announcements__item'));
        if (found > -1) { this.show(found); this.paused = true; }
      });
      this.addEventListener('shopify:block:deselect', resume);
      this.timer = setInterval(() => {
        if (!this.paused && !document.hidden) this.show((this.index + 1) % this.items.length);
      }, this.delay);
    }

    disconnectedCallback() { clearInterval(this.timer); }

    show(next) {
      this.items.forEach((item, i) => {
        const active = i === next;
        item.classList.toggle('is-active', active);
        if (active) item.removeAttribute('aria-hidden');
        else item.setAttribute('aria-hidden', 'true');
      });
      this.index = next;
    }
  });
}
